import { lifeAreaConverter as _lifeAreaConverter } from '@griply/services';
import { LifeArea, LocalizedLifeArea } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const lifeAreaConverter =
  _lifeAreaConverter as unknown as FirestoreDataConverter<
    LifeArea | LocalizedLifeArea
  >;
